module.exports = __webpack_public_path__ + "img/805138fc9deb80338ced0af69eb89a6.d6b94d7c.png";